module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "A5m"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Copyright Page"
    }
  }, [_c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pAr"
    }
  }, [_vm._v("© 1991, 1993, 1995, 1997 by H. Jackson Brown, Jr.")]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    attrs: {
      "id": "A7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "AtN",
      "role": "presentation",
      "src": "images/himg-2-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pAb"
    }
  }, [_vm._v("All rights reserved. Written permission must be secured from the publisher to use or reproduce any "), _c('br'), _vm._v(" part of this book, except for brief quotations in critical reviews or articles.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pA1"
    }
  }, [_vm._v("Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson "), _c('br'), _vm._v(" is a registered trademark of HarperCollins Christian Publishing, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pAC"
    }
  }, [_vm._v("Thomas Nelson titles may be purchased in bulk for educational, business, fund-raising, or sales "), _c('br'), _vm._v(" promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2",
    attrs: {
      "id": "pAR"
    }
  }, [_vm._v("Design by Gary Gore | Typography by D&T/Bailey Typesetting, Inc., Nashville, Tennessee"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "isbn1"
  }, [_c('span', {
    staticClass: "digits"
  }, [_vm._v("978-1-4185-7129-0")]), _vm._v(" (eBook)")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress1",
    attrs: {
      "id": "pAdm"
    }
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress2",
    attrs: {
      "id": "pAA"
    }
  }, [_vm._v("Brown, H. Jackson, 1940–")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress3",
    attrs: {
      "id": "pAP1"
    }
  }, [_vm._v("[Life’s little instruction book]")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress3",
    attrs: {
      "id": "pAMX"
    }
  }, [_vm._v("The complete life’s little instruction book / H. Jackson Brown, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress4",
    attrs: {
      "id": "pAg"
    }
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress3",
    attrs: {
      "id": "pA27"
    }
  }, [_vm._v("Originally published in 3 vols. : Life’s little instruction book.")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress5",
    attrs: {
      "id": "pAu"
    }
  }, [_vm._v("Nashville, Tenn. : Rutledge Hill Press, c1991–c1995.")]), _vm._v(" "), _c('p', {
    staticClass: "isbn",
    attrs: {
      "id": "pA8"
    }
  }, [_vm._v("ISBN 978-1-55853-490-2")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress3",
    attrs: {
      "id": "pAj"
    }
  }, [_vm._v("1. Happiness—Quotations, maxims, etc. 2. Conduct of life—")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress5",
    attrs: {
      "id": "pAT"
    }
  }, [_vm._v("Quotations, maxims, etc. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress5",
    attrs: {
      "id": "pAL"
    }
  }, [_vm._v("[BJ1481.B87 1997]")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress5",
    attrs: {
      "id": "pALo"
    }
  }, [_vm._v("170’.44—dc21     97-5575")]), _vm._v(" "), _c('p', {
    staticClass: "libraryofcongress6",
    attrs: {
      "id": "pAz"
    }
  }, [_c('span', {
    staticClass: "spell"
  }, [_vm._v("CIP")])]), _vm._v(" "), _c('p', {
    staticClass: "other",
    attrs: {
      "id": "pAE"
    }
  }, [_vm._v("19 20 21 22 23 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("SHR")]), _vm._v(" 29 28 27 26 25")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e587cc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0